import { useQuery } from '@tanstack/react-query';
import { clubSalesOrderService } from '@/services/club-sales-order.service';

export function usePendingOrderCount(enabled = true): number {
  const { data } = useQuery({
    queryKey: ['club-sales-orders', 'pending-count'],
    queryFn: () => clubSalesOrderService.getStats(),
    staleTime: 60_000,
    enabled,
  });
  return data?.pendingApproval ?? 0;
}
